import { formatDate } from 'node_modules/@angular/common';
import { APP_LOCALE } from 'src/app/constants';
import { MonthAdapter, ServerMonth, TsMonth } from 'src/app/month.util';

export interface Business {
	Id?: number;
	Name: string;
	Tin: string;
	Brn: string;
	Ttx?: string;
	Sst?: string;
	Remark?: string;
	OldRegNo?: string;
	Directors: string;
	BusinessType: string;
	SsmExpiryDate?: Date;
	YearEndMonth?: TsMonth;
	RequireConsentForm?: boolean;
	CreatedBy?: string;
	CreatedOn?: Date;
	Active?: boolean;
}

export function createEmptyBusiness(): Business {
	return {
		Name: '',
		Tin: '',
		Brn: '',
		Directors: '',
		BusinessType: ''
	};
}

// --- Mapper -------------------------------------------------------------------------------------

export interface BusinessDTO {
	name: string;
	tin: string;
	brn: string;
	sstNo?: string;
	ttxNo?: string;
	oldRegNo?: string;
	remark?: string;
	requireConsentForm: boolean;
	directors: string;
	businessType: string;
	ssmExpiryDate?: string;
	fiscalYearEndMonth?: ServerMonth;

	// GET
	id?: number;
	createdBy?: string;
	createdOn?: string;
	invalidatedOn?: string;
}

export function adaptBusiness(item: Partial<BusinessDTO>): Business {
	return {
		Id: item.id,
		Name: item.name,
		Tin: item.tin,
		Brn: item.brn,
		Ttx: item.ttxNo,
		Sst: item.sstNo,
		Remark: item.remark,
		OldRegNo: item.oldRegNo,
		CreatedBy: item.createdBy,
		CreatedOn: new Date(item.createdOn),
		Active: item.invalidatedOn === undefined,
		RequireConsentForm: item.requireConsentForm,
		Directors: item.directors,
		BusinessType: item.businessType,
		SsmExpiryDate: item.ssmExpiryDate && new Date(item.ssmExpiryDate),
		YearEndMonth: MonthAdapter.adapt(item.fiscalYearEndMonth)
	};
}

export function toApiBusiness(business: Business): BusinessDTO {
	return {
		name: business.Name,
		tin: business.Tin,
		brn: business.Brn,
		...(business.Sst && { sstNo: business.Sst }),
		...(business.Ttx && { ttxNo: business.Ttx }),
		...(business.OldRegNo && { oldRegNo: business.OldRegNo }),
		...(business.Remark && { remark: business.Remark }),
		...(business.RequireConsentForm && { requireConsentForm: business.RequireConsentForm }),
		directors: business.Directors,
		businessType: business.BusinessType,
		...(business.SsmExpiryDate && { ssmExpiryDate: formatDate(new Date(business.SsmExpiryDate), 'yyyy-MM-dd', APP_LOCALE) }),
		...(business.YearEndMonth && { fiscalYearEndMonth: MonthAdapter.toApi(business.YearEndMonth) })
	};
}

// --- Constant -----------------------------------------------------------------------------------

export const BUSINESS_TYPE: string[] = ['SDN BHD', 'PERKONGSIAN', 'PEMILIKAN TUNGGAL'] as const;
